<div *ngIf="visible" id="cookie-warning" class="bg-brand-secondary">
  <i class="fas fa-2x fa-window-close" (click)="accept()"></i>
  <i class="fas fa-2x fa-info-circle"></i>
  <p> Our website uses cookies to improve your experience. Continuing to use this website will be considered consent.&nbsp;&nbsp;&nbsp;<a href="//www.aqmesh.com/wp-content/uploads/2018/04/AQMesh-website-privacy-policy.pdf">Read Privacy Policy</a></p>
</div>